import { createRouter, createWebHashHistory } from "vue-router";
import PublicEnter from "../views/PublicEnter.vue";
// import PublicEnterF from "../views/PublicEnterF.vue";

const routes = [
  {
    path: "/PublicEnter/:sourceId",
    name: "PublicEnter",
    component: PublicEnter,
    //  component: () => import("../views/PublicEnter.vue"),
  },
  {
    path: "/PublicEnterF/:sourceId",
    name: "PublicEnterF",
    component: () => import("../views/PublicEnterF.vue"),
  },
  {
    path: "/PublicEnterOld/:sourceId",
    name: "PublicEnterOld",
    component: () => import("../views/PublicEnterOld.vue"),
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
});
export default router;
